import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import routerButton from "@/components/buttoncard/routerButton.vue";
import { ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'homePageIndex',
  setup(__props) {

const title = ref("首页");
const color = ref("#00000007");
const height = ref("20");
const width = ref("80");
const icon = ref("图标");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (i) => {
      return _createVNode(routerButton, {
        key: i,
        title: title.value,
        color: color.value,
        height: height.value,
        width: width.value,
        icon: icon.value
      }, null, 8, ["title", "color", "height", "width", "icon"])
    }), 64))
  ]))
}
}

})